<div class="loader-overlay"><div v-if="loading" :class="cssClasses"><Loader class="loader" size="5x"></Loader></div><slot></slot></div>